import { render, staticRenderFns } from "./noSalesPartner.vue?vue&type=template&id=4acf1760&"
import script from "./noSalesPartner.vue?vue&type=script&lang=js&"
export * from "./noSalesPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports